/** The signed payment choice controls the charge; old orders remain 50% deposits. */
export type BuildPaymentMode = 'deposit' | 'full';
export function buildPaymentDueCents(total: number, credit: boolean, mode: BuildPaymentMode = 'deposit'): number {
  if (!Number.isFinite(total) || total <= 0) return 0;
  return Math.max(0, Math.round(total * (mode === 'full' ? 100 : 50)) - (credit ? 14900 : 0));
}
export function signedPaymentMode(signed: {paymentMode?: unknown} | null | undefined): BuildPaymentMode {
  return signed?.paymentMode === 'full' ? 'full' : 'deposit';
}
